import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Webcam from "react-webcam";

// MUI Components
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Slide from "@material-ui/core/Slide";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import classNames from "classnames";
import {
  receivePicture,
  setCameraModal,
  cancelPhoto,
  updateSamplesSavedFlag,
  setAcquiring,
  errorResponse,
  selectSample,
  setMainViewSection,
  fetchFaceDetection,
  setFocusElement,
} from "../../actions";

import Dropzone from "../Shared/Dropzone";
import { colors } from "../../constants/colors";
import { customTheme } from "../../constants/customTheme";

//Icons
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import FolderIcon from "@material-ui/icons/Folder";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const styles = {
  root: {
    flex: "1 1 auto",
    flexDirection: "column",
    marginTop: "20px",
    zIndex: 5,
  },
  paperProps: {
    overflow: "hidden",
    width: "90%",
    height: "95%",
    maxWidth: "900px",
    maxHeight: "680px",
    zIndex: 5,
  },
  buttonContainer: {
    marginRight: "15px",
    zIndex: 5,
  },
  button: {
    textColor: "white",
    backgroundColor: (props) => colors[props.theme].primary,
    "&:hover": {
      backgroundColor: (props) => colors[props.theme].primaryLight,
    },
    zIndex: 5,
    marginRight: "5px",
    marginLeft: "5px",
  },
  secondaryButton: (props) => ({
    ...customTheme(props.theme).buttonOutlined,
    zIndex: 5,
    marginRight: "5px",
    marginLeft: "5px",
  }),
  fromControl: (props) => ({
    marginLeft: "15px",
    width: "225px",
    "& .MuiFormLabel-root.Mui-focused": {
      color: colors[props.theme].primary,
    },
    "& .MuiInput-underline:after": {
      borderBottom: `2px solid ${colors[props.theme].primary}`,
    },
    "& div": {
      flex: "1 1 auto",
    },
  }),
  dialogContent: {
    paddingTop: 0,
    paddingBottom: 0,
    display: "flex",
    zIndex: 5,
  },
  firstAction: {
    justifyContent: "space-between",
  },
  cameraTitle: {
    marginBottom: "20px",
  },
  buttonProgress: (props) => ({
    ...customTheme(props.theme).buttonProgress,
    color: colors[props.theme].primary,
  }),
  appBar: {
    backgroundColor: (props) => colors[props.theme].headerBkg,
    height: "40px",
    "& .MuiTabs-root": {
      height: "40px",
      "& .MuiTabs-fixed": {
        height: "40px",
      },
    },
  },
  tab: {
    flexBasis: "unset",
    height: "40px",
    flexShrink: "unset",
    minHeight: "unset",
    "& .MuiTab-wrapper": {
      ...customTheme().tabTitle,
      fontSize: "1.0rem",
      flexDirection: "unset",
      textTransform: "capitalize",
      "& .MuiSvgIcon-root": {
        marginRight: "10px",
        marginBottom: "0px",
      },
      zIndex: 5,
    },
  },
};

class CameraModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.camRef = React.createRef();
    this.canvasRef = React.createRef();
    // Local state variables
    this.state = {
      selectedCameraId: null,
      cameras: null,
      picture: null,
      camReady: false,
      uuid: this.props.sampleUuid,
      windowHeight: null,
      tab: "CAMERA",
      cameraTopOffset: null,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.interval = setInterval(() => this.checkWebcamStatus(), 1000);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillMount() {
    this.handleFindCamera();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate() {
    if (this.canvasRef !== null) {
      this.addOval();
    }
  }

  updateWindowDimensions() {
    let winHeight = window.innerHeight * 0.7 - 10;
    if (winHeight > 637.5) {
      winHeight = 637.5;
    }
    this.setState({
      ...this.state,
      windowHeight: winHeight,
    });
  }

  handleFindCamera() {
    // Search through the camera device to find the back/rear camera
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        // Get all cameras on the device
        let deviceCameras = devices.filter(function (device) {
          return device.kind === "videoinput";
        });

        let selectedCameraId = null;
        let cameras = {};

        // Iterate over device cameras
        deviceCameras.forEach((camera) => {
          cameras[camera.deviceId] = {
            id: camera.deviceId,
            name: camera.label,
          };

          // try to find back/rear camera
          if (camera.label.toLowerCase().search("back") > -1) {
            selectedCameraId = camera.deviceId;
          } else if (camera.label.toLowerCase().search("rear") > -1) {
            selectedCameraId = camera.deviceId;
          }
        });

        // If no back/rear camera is found then use the first camera in the list
        if (!selectedCameraId && deviceCameras.length) {
          selectedCameraId = deviceCameras[0].deviceId;
        }

        this.setState({
          ...this.state,
          cameras: { ...cameras },
          selectedCameraId: selectedCameraId,
        });

        // If no cameras are found then cancel photo acquisition and display snackbar error
        if (Object.keys(cameras).length === 0) {
          this.handleCancel();
          this.props.errorResponse("No camera found");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleCameraChange(e) {
    this.setState({
      ...this.state,
      selectedCameraId: e.target.value,
    });
  }

  handleCapture() {
    const imageSrc = this.camRef.current.getScreenshot();
    this.setState({
      ...this.state,
      picture: imageSrc,
      camReady: false,
    });
  }

  handleSubmit() {
    if (this.props.sampleUuid === null) {
      this.props.fetchFaceDetection(this.state.picture);
    } else {
      // Add picture to sample's redux state
      this.props.receivePicture(this.props.sampleUuid, this.state.picture);
      this.props.selectSample(this.props.sampleUuid);
      // Reset the local state
      this.setState({
        ...this.state,
        picture: null,
      });
      // Close the camera modal
      this.props.setCameraModal(false, null);
      this.props.setAcquiring(false);
    }
  }

  handlePhotoUpload(base64Image) {
    this.setState({
      ...this.state,
      picture: base64Image,
    });
  }

  checkWebcamStatus = () => {
    const cam = this.camRef.current;
    if (cam && cam.state.hasUserMedia) {
      this.setState({
        ...this.state,
        camReady: true,
      });
      clearInterval(this.interval);
    }
  };

  mediaStreamInitiated = () => {};

  handleRetake() {
    // Retake picture. Reset the local "picture" state to take a new picture
    this.setState({
      ...this.state,
      picture: null,
    });
    this.interval = setInterval(() => this.checkWebcamStatus(), 1000);
  }

  handleCancel() {
    // Reset the local state
    clearInterval(this.interval);
    this.setState({
      ...this.state,
      picture: null,
      camReady: false,
    });

    // Change redux variables to cancel the photo sample
    this.props.setMainViewSection("sampleFocused");
    this.props.cancelPhoto(this.props.sampleUuid); // remove photo sample from redux state
    this.props.updateSamplesSavedFlag();
    this.props.setCameraModal(false, null); // close modal
    this.props.setAcquiring(false);
  }

  addOval = () => {
    this.updateWindowDimensions();
    let canvas = this.canvasRef.current;
    let canvasHeight;
    let canvasWidth;
    if (document.getElementById("videoCamera") !== null) {
      let videoSize = document
        .getElementById("videoCamera")
        .getBoundingClientRect();
      canvasWidth = videoSize.right - videoSize.left;
      canvasHeight = videoSize.bottom - videoSize.top;
      if (canvasHeight > 585) {
        canvasHeight = 585;
      }
      if (canvasWidth > 850) {
        canvasWidth = 850;
      }
      this.setState({ ...this.state, cameraTopOffset: videoSize.top });
      if (canvasWidth === 300 && canvasHeight === 150) {
        canvasHeight = 480;
        canvasWidth = 640;
      }
    } else {
      canvasHeight = this.state.windowHeight;
      canvasWidth = window.innerWidth * 0.6 - 10;
    }
    if (canvas !== null) {
      const ctx = canvas.getContext("2d");
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      ctx.fillStyle = colors[this.props.theme].cameraBackground;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = "xor";
      ctx.strokeStyle = colors[this.props.theme].cameraBackground;
      ctx.beginPath();
      ctx.ellipse(
        canvas.width / 2,
        canvas.height / 2,
        canvas.width / 6,
        canvas.height / 3,
        0,
        0,
        2 * Math.PI
      );
      ctx.closePath();
      ctx.fill();
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        TransitionComponent={Transition}
        disableBackdropClick={true}
        open={this.props.open}
        onClose={() => this.handleCancel()}
        PaperProps={{ className: classNames(classes.paperProps) }}
      >
        <AppBar color="default" className={classes.appBar} position="static">
          <Tabs
            value={this.state.tab}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            onChange={(event, newValue) => {
              this.setState({ ...this.state, tab: newValue });
            }}
          >
            <Tab
              label="Camera"
              value="CAMERA"
              icon={<CameraAltIcon />}
              className={classes.tab}
            />
            <Tab
              label="Upload Photo"
              value="UPLOAD"
              icon={<FolderIcon />}
              className={classes.tab}
            />
          </Tabs>
        </AppBar>
        <DialogContent className={classes.dialogContent}>
          <Grid
            item
            container
            className={classes.gridItem}
            alignItems="center"
            justify="center"
          >
            {this.state.tab === "CAMERA" ? (
              this.state.picture === null ? (
                // Camera Feed
                <>
                  <>
                    <Webcam
                      id="videoCamera"
                      audio={false}
                      ref={this.camRef}
                      height={this.state.windowHeight}
                      mirrored={true}
                      onUserMedia={this.mediaStreamInitiated()}
                      screenshotFormat="image/jpeg"
                      videoConstraints={{
                        deviceId: {
                          exact: this.state.selectedCameraId,
                        },
                      }}
                      style={{
                        display: this.state.camReady ? "block" : "none",
                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                      }}
                    />
                  </>

                  {this.props.sampleUuid === null && (
                    <canvas
                      id="canvas"
                      ref={this.canvasRef}
                      style={{
                        position: "absolute",
                        opacity: 0.5,
                        zIndex: 1,
                      }}
                    />
                  )}
                  {this.state.camReady || (
                    <Grid
                      item
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      style={{
                        height: this.state.windowHeight, //innerHeight*0.7-10,
                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography className={classes.cameraTitle}>
                        Connecting to Camera...
                      </Typography>
                      <CircularProgress />
                    </Grid>
                  )}
                </>
              ) : (
                // Image Preview
                <img
                  height={this.state.windowHeight}
                  alt={"Camera capture by the user"}
                  src={this.state.picture}
                />
              )
            ) : this.state.picture === null ? (
              <Dropzone
                formatError={(errorMessage) =>
                  this.props.errorResponse(errorMessage)
                }
                upload={(base64String) => {
                  this.handlePhotoUpload(base64String);
                }}
                acceptedFormat={[".png", ".jpg"]}
                readFile={true}
              />
            ) : (
              <img
                height={this.state.windowHeight}
                alt={"Camera capture by the user"}
                src={this.state.picture}
              />
            )}
          </Grid>
        </DialogContent>
        {this.state.tab === "CAMERA" ? (
          this.state.picture === null ? (
            // Take Photo
            <DialogActions className={classes.firstAction}>
              <FormControl className={classes.fromControl}>
                {this.state.selectedCameraId !== null &&
                  this.state.cameras !== null && (
                    // Camera Select Dropdown
                    <Select
                      value={this.state.selectedCameraId}
                      onChange={(e) => this.handleCameraChange(e)}
                    >
                      {Object.keys(this.state.cameras).map((camera) => {
                        return (
                          <MenuItem
                            key={this.state.cameras[camera].id}
                            value={this.state.cameras[camera].id}
                          >
                            {this.state.cameras[camera].name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  )}
              </FormControl>
              {this.state.camReady && this.state.uuid === null && (
                <Typography>Place face in the oval and take photo</Typography>
              )}
              <div className={classes.buttonContainer}>
                <Button
                  onClick={() => this.handleCancel()}
                  variant="outlined"
                  className={classes.secondaryButton}
                  disabled={!this.state.camReady}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => this.handleCapture()}
                  className={classes.button}
                  variant="contained"
                  disabled={!this.state.camReady}
                >
                  Take Photo
                </Button>
              </div>
            </DialogActions>
          ) : (
            // Confirm / Retake
            <DialogActions>
              <Button
                onClick={() => this.handleRetake()}
                className={classes.secondaryButton}
                disabled={this.props.fetchingFaceDetection}
                variant="outlined"
              >
                Retake Photo
              </Button>

              <Button
                onClick={() => this.handleSubmit()}
                className={classes.button}
                autoFocus
                variant="contained"
                disabled={this.props.fetchingFaceDetection}
              >
                {this.props.fetchingFaceDetection && (
                  <CircularProgress
                    size={25}
                    className={classes.buttonProgress}
                  />
                )}
                Use Photo
              </Button>
            </DialogActions>
          )
        ) : this.state.picture === null ? (
          <DialogActions>
            <Button
              onClick={() => this.handleCancel()}
              className={classes.secondaryButton}
              variant="outlined"
            >
              Cancel
            </Button>
          </DialogActions>
        ) : (
          <DialogActions>
            <Button
              onClick={() => this.handleRetake()}
              className={classes.secondaryButton}
              disabled={this.props.fetchingFaceDetection}
              variant="outlined"
            >
              Upload New Photo
            </Button>

            <Button
              onClick={() => this.handleSubmit()}
              className={classes.button}
              autoFocus
              variant="contained"
              disabled={this.props.fetchingFaceDetection}
            >
              {this.props.fetchingFaceDetection && (
                <CircularProgress
                  size={25}
                  className={classes.buttonProgress}
                />
              )}
              Use Photo
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      receivePicture,
      setCameraModal,
      cancelPhoto,
      updateSamplesSavedFlag,
      setAcquiring,
      setMainViewSection,
      errorResponse,
      selectSample,
      fetchFaceDetection,
      setFocusElement,
    },
    dispatch
  );
};
const mapStateToProps = (state) => {
  return {
    selectedLocationId: state.locations.selectedLocationId,
    sampleUuid: state.utility.cameraModal.id,
    open: state.utility.cameraModal.status,
    location: state.locations.selectedLocationId,
    fetchingFaceDetection: state.utility.fetchingFaceDetection,
    theme: state.utility.theme,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CameraModal));
